import api from '@/api/api'
import { useRequestsStore } from '@/stores/requests'
import type { JobSearchItem, SearchFilter } from '@/types/JobSearch'

export async function searchJobs(
  searchText: string,
  filters: SearchFilter[] = []
) {
  useRequestsStore().Search.increment()
  const { status, data } = await api.post<JobSearchItem[]>('/jobs/search', {
    filters,
    searchText,
  })
  useRequestsStore().Search.decrement()

  return status === 200 ? data : []
}
